'use client';

import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { ENTITY_NAME, ENTITY_SECTION } from '../constants';
import type { TravelNerdBannerAnalytics } from '../types';
import { ActivityIdProvider, useActivityId } from './ActivityIdProvider';

const FeatureViewedWrapper = ({
  children,
  analytics,
}: {
  children: React.JSX.Element;
  analytics?: TravelNerdBannerAnalytics;
}) => {
  const activityId = useActivityId();

  return (
    <FeatureViewed
      entityName={ENTITY_NAME}
      entitySection={ENTITY_SECTION}
      impressionPosition={analytics?.impressionPosition || 0}
      activityId={activityId}
    >
      {children}
    </FeatureViewed>
  );
};
export const AnalyticsWrapper = ({
  children,
  analytics,
}: {
  children: React.JSX.Element;
  analytics?: TravelNerdBannerAnalytics;
}) => {
  return (
    <ActivityIdProvider>
      <FeatureViewedWrapper analytics={analytics}>{children}</FeatureViewedWrapper>
    </ActivityIdProvider>
  );
};
